// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2020":"6876d96f","5466":"6876d96f"}[chunkId] + ".chunk.css";
};